/**
 * 验证密码强度
 * @param sValue
 * @returns {number|number}
 */
export function checkStrong(sValue) {
  let modes = 0
  // 正则表达式验证符合要求的
  if (sValue.length < 1) return modes
  if (/\d/.test(sValue)) modes++ // 数字
  if (/[a-z]/.test(sValue)) modes++ // 小写
  if (/[A-Z]/.test(sValue)) modes++ // 大写

  // 逻辑处理
  switch (modes) {
    case 1:
      return 1
    case 2:
      return 2
    case 3:
      return sValue.length < 8 ? 2 : 3
  }
  return modes
}

/**
 * 获取文件后缀名
 * @param fileName
 * @returns {string}
 */
export function getFileSuffix(fileName) {
  let suffix = ''
  let index = fileName.lastIndexOf('.')
  if (index >= 0) {
    suffix = fileName.substr(index)
  }
  return suffix
}



// WEBPACK FOOTER //
// ./src/utils/function/index.js